<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ toolbarTitle }}</v-toolbar-title>
    </v-toolbar>
    <div class="loading spacing-top" v-if="loadingAll">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs2 pr-2>
                <v-select v-model="condition.temporada" label="Temporada" required :error-messages="temporadaErrors"
                        :items="seasons" item-text="nombre" item-value="pk" :readonly="condicionIsTerminada"></v-select>
            </v-flex>
            <v-flex xs6 pr-2>
                <v-select v-model="condition.contrato" label="Contrato" required :error-messages="contratoErrors"
                          :items="contratos" item-value="id" item-text="contractType" :readonly="condicionIsTerminada">
                          <template slot="selection" slot-scope="contrato">
                              {{ contrato.item | formatContrato }}
                          </template>
                          <template slot="item" slot-scope="contrato">
                              {{ contrato.item | formatContrato}}
                          </template>
                </v-select>
            </v-flex>
            <v-flex xs2 pr-2>
                <DatePickerForm v-model="condition.fechaInicio" required :error-messages="fechaInicioErrors"
                label="Fecha de inicio de las cláusulas" :readonly="!condition.contrato && condicionIsTerminada"></DatePickerForm>
            </v-flex>
            <v-flex xs2 pr-2>
                <DatePickerForm v-model="condition.fechaFin" :error-messages="fechaFinErrors"
                required label="Fecha de fin de las cláusulas" :readonly="!condition.contrato && condicionIsTerminada"></DatePickerForm>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs pr-2>
                <v-autocomplete v-model="condition.concepto" label="Concepto" :error-messages="conceptoErrors"
                            :items="conceptos" item-text="nombre" item-value="id" :readonly="condicionIsTerminada"></v-autocomplete>
            </v-flex>
            <v-flex xs3 pr-2>
                <v-autocomplete v-model="condition.tipoDeCondicion" label="Tipo de condición" :error-messages="tipoDeCondicionErrors"
                            :items="tiposDeCondicion" item-text="nombre" item-value="id" :readonly="condicionIsTerminada"></v-autocomplete>
            </v-flex>
            <v-flex xs6 pr-2>
                <v-currency-field v-model="condition.tope" type="number" label="Tope" :readonly="condicionIsTerminada"></v-currency-field>
            </v-flex>
            <v-flex xs6 pr-2>
                <v-currency-field required v-model="condition.importe" type="number" label="Importe"
                :error-messages="importeErrors" :readonly="condicionIsTerminada"></v-currency-field>
            </v-flex>
            <v-flex xs3 pr-2>
                <v-select v-model="condition.moneda" label="Moneda" :items="monedas" :error-messages="monedaErrors" :readonly="condicionIsTerminada"></v-select>
            </v-flex>
            <v-flex xs3 pr-2>
                <v-select v-model="condition.tipoImporte" label="Bruto/Neto" :items="brutoONeto"
                :error-messages="tipoImporteErrors" :readonly="condicionIsTerminada"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 pr-2>
                <v-select v-model="condition.frecuencia" label="Frecuencia" :items="frecuencias" required
                :error-messages="frecuenciaErrors" :readonly="condicionIsTerminada"></v-select>
            </v-flex>

            <v-flex xs6 pr-2 v-show="this.condition.frecuencia===1">
                <v-text-field v-model="condition.cuotas" label="Cuotas" :error-messages="cuotasErrors" type="number" :readonly="condicionIsTerminada"></v-text-field>
            </v-flex>
            <v-flex xs6 pr-2 v-show="this.condition.frecuencia===1">
                <DatePickerForm v-model="condition.primerVencimiento" :error-messages="primerVencimientoErrors"
                label="Primer vencimiento" :readonly="condicionIsTerminada"></DatePickerForm>
            </v-flex>
            <v-flex xs6 pr-2 v-show="this.condition.frecuencia===1">
                <v-text-field v-model="condition.siguienteVencimiento" :error-messages="siguienteVencimientoErrors"
                label="Siguiente vencimiento" type="number" :readonly="condicionIsTerminada"></v-text-field>
            </v-flex>
             <v-flex xs3 v-if="esMoneda">
               <v-autocomplete v-model="condition.tipoDeCambio" label="Tipo de Cambio" :error-messages="tipoDeCambioErrors"
                            :items="tiposDeCambio" item-text="codeDescription" item-value="id"  v-on:change="onTipoCambioChange" :readonly="condicionIsTerminada">
               </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs9 pr-2>
                <v-textarea v-model="condition.observaciones" label="Observaciones" :readonly="condicionIsTerminada"></v-textarea>
            </v-flex>
            <v-flex xs3 pr-2 v-if="esMoneda">
              <v-textarea v-model="condition.descripcionTipoDeCambio" label="Descripción de Tipo de Cambio"
                :error-messages="descripcionTipoDeCambioErrors" :readonly="condicionIsTerminada"></v-textarea>
            </v-flex>
          </v-layout>
          <div v-if="condicionIsTerminada">
            <span>Terminado el {{ condition.fechaCierre }}</span>
            <br/>
            <span>Motivo: {{ condition.motivoCierre }}</span>
          </div>
          <confirmation-dialog :function-yes="bindingFunction" ref="confirm" title="Abandonar formulario"
                    text="Se perderán los cambios del formulario actual, ¿desea continuar?"></confirmation-dialog>
          <terminar-condicion-dialog ref="terminarDialog" :condicionId='condicionId' @condicionTerminada="condicionTerminada"
          :fecha-inicio-minima="condition.fechaInicio"></terminar-condicion-dialog>

          <v-btn class="mx-0" @click="volverAPersonal">Volver</v-btn>
          <v-btn @click="terminarCondicion" color="red" v-if="isEditing && !condicionIsTerminada">Terminar</v-btn>
          <v-btn @click="terminarCondicionYRenovar" color="blue" v-if="isEditing && !condicionIsTerminada">Terminar y renovar</v-btn>
          <v-btn @click="submit" color="primary" v-if="isRenovando">Renovar</v-btn>
          <v-btn @click="submit" color="primary" v-else-if="!condicionIsTerminada">{{ (isEditing) ? 'Guardar':'Crear' }}</v-btn>
          <v-btn @click="renovarCondicion" color="primary" v-else-if="!contratoTerminado">Renovar</v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import TerminarCondicionDialog from '../components/TerminarCondicionDialog'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import Constants from '../../../common/constants'

const MENSUAL = 0
const ACTIVO = 0
const ANUAL = 1

export default {
  mixins: [validationMixin, createEntityMixin],
  validations: {
    condition: {
      importe: { required },
      temporada: { required },
      fechaInicio: { required },
      fechaFin: { required },
      contrato: { required },
      concepto: { required },
      tipoDeCondicion: { required },
      moneda: { required },
      tipoImporte: { required },
      frecuencia: { required },
      descripcionTipoDeCambio: {
        required: requiredIf(function (cuotas) {
          return this.esMoneda
        }) },
      cuotas: {
        required: requiredIf(function (cuotas) {
          return this.condition.frecuencia === ANUAL
        }) },
      primerVencimiento: {
        required: requiredIf(function (primerVencimiento) {
          return this.condition.frecuencia === ANUAL
        }) },
      siguienteVencimiento: {
        required: requiredIf(function (siguienteVencimiento) {
          return this.condition.frecuencia === ANUAL
        }) },
      tipoDeCambio: {
        required: requiredIf(function (cuotas) {
          return this.esMoneda
        }) }
    }
  },

  filters: {
    formatContrato (contrato) {
      return `${contrato.contractType} - ${contrato.statusDisplay} - ${contrato.startDate} > ${contrato.endDate}`
    }
  },

  components: {
    DatePickerForm,
    ConfirmationDialog,
    TerminarCondicionDialog
  },

  data () {
    return {
      condition: {
        contratoObj: {
          pk: 0
        },
        tope: 0,
        frecuencia: MENSUAL
      },
      loadingConceptos: true,
      loadingContratos: true,
      loadingTiposDeCondicion: true,
      loadingCondicion: true,
      loadingSeasons: true,
      createPath: '/condiciones/new',
      editPath: `condicion/${this.$route.params.id}`,
      playerName: '',
      saving: false,
      monedas: [],
      brutoONeto: [
        {
          text: 'Bruto',
          value: Constants.BRUTO
        },
        {
          text: 'Neto',
          value: Constants.NETO
        }
      ],
      frecuencias: [
        {
          text: 'Mensual',
          value: MENSUAL
        },
        {
          text: 'Anual',
          value: ANUAL
        }
      ],
      seasons: [],
      conceptos: [],
      contratos: [],
      tiposDeCondicion: [],
      fechaFinMaximaSegunContrato: null,
      fechaInicioMinimaSegunContrato: null,
      renovar: false,
      tiposDeCambio: []
    }
  },
  computed: {
    contratoTerminado () {
      return this.condition.contratoObj.status === 'Finalizado'
    },
    loadingAll () {
      if (this.isEditing) {
        return this.loadingCondicion || this.loadingConceptos || this.loadingTiposDeCondicion || this.loadingContratos || this.loadingSeasons
      } else {
        return this.loadingConceptos || this.loadingTiposDeCondicion || this.loadingContratos || this.loadingSeasons
      }
    },
    condicionId () {
      return this.$route.params.id
    },
    descripcionTipoDeCambioErrors () {
      return this.getRequiredErrors('condition.descripcionTipoDeCambio')
    },
    temporadaErrors () {
      return this.getRequiredErrors('condition.temporada')
    },
    fechaInicioErrors () {
      let errors = this.getRequiredErrors('condition.fechaInicio')
      if (this.$v.condition['fechaInicio'].$dirty && !this.isValidStartDateTemporada()) {
        errors.push('La fecha de inicio debe ser posterior a la fecha de inicio de la temporada')
      }
      return errors
    },
    fechaFinErrors () {
      let errors = this.getRequiredErrors('condition.fechaFin')
      if (this.$v.condition['fechaFin'].$dirty) {
        if (!this.isValidEndDate()) {
          errors.push('La fecha de fin debe ser posterior a la de inicio')
        }
        if (!this.isValidEndDateContract()) {
          errors.push('La fecha de fin debe ser anterior a la fecha de fin del contrato')
        }
        if (!this.isValidEndDateTemporada()) {
          errors.push('La fecha de fin debe ser anterior a la fecha de fin de la temporada')
        }
      }
      return errors
    },
    importeErrors () {
      return this.getRequiredErrors('condition.importe')
    },
    contratoErrors () {
      return this.getRequiredErrors('condition.contrato')
    },
    frecuenciaErrors () {
      return this.getRequiredErrors('condition.frecuencia')
    },
    conceptoErrors () {
      return this.getRequiredErrors('condition.concepto')
    },
    monedaErrors () {
      return this.getRequiredErrors('condition.moneda')
    },
    tipoImporteErrors () {
      return this.getRequiredErrors('condition.tipoImporte')
    },
    cuotasErrors () {
      return this.getRequiredErrors('condition.cuotas')
    },
    tipoDeCondicionErrors () {
      return this.getRequiredErrors('condition.tipoDeCondicion')
    },
    tipoDeCambioErrors () {
      return this.getRequiredErrors('condition.tipoDeCambio')
    },
    primerVencimientoErrors () {
      let errors = this.getRequiredErrors('condition.primerVencimiento')
      if (this.$v.condition['primerVencimiento'].$dirty && !this.isValidPrimerVencimiento()) {
        errors.push('El primer vencimiento debe ser posterior a la fecha de inicio')
      }
      return errors
    },
    siguienteVencimientoErrors () {
      return this.getRequiredErrors('condition.siguienteVencimiento')
    },
    isEditing () {
      return this.$route.params.hasOwnProperty('id') && !this.isRenovando
    },
    isRenovando () {
      return this.$route.name === 'renovarCondicion'
    },
    condicionIsTerminada () {
      return !(this.condition.estado === ACTIVO || this.isRenovando || !this.isEditing)
    },
    toolbarTitle () {
      if (this.isRenovando) {
        return `Renovar condición salarial para ${this.playerName}`
      } else if (this.isEditing) {
        if (!this.condicionIsTerminada) {
          return `Editar condición salarial para ${this.playerName}`
        } else {
          return `Ver condición salarial para ${this.playerName}`
        }
      }
      return 'Crear condición salarial'
    },
    esMoneda () {
      return this.condition.moneda != null
    }
  },

  methods: {
    fetchData () {
      if (this.isEditing || this.isRenovando) {
        this.fetchCondition()
      } else {
        this.personalId = this.$route.params.personalId
        this.clubId = this.$route.params.clubId
        this.fetchContratos()
      }
      this.fetchConceptos()
      this.fetchTiposDeCondicion()
      this.fetchSeasons()
      this.fetchMonedas()
    },
    fetchContratos () {
      let contratosPath = `condicion/contratos/${this.personalId}/${this.clubId}`
      if (this.isEditing) {
        contratosPath = `${contratosPath}/${this.condicionId}`
      }
      this.axios
        .get(contratosPath)
        .then(response => {
          this.contratos = response.data.results
          this.loadingContratos = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchConceptos () {
      this.axios
        .get('/conceptos')
        .then(response => {
          this.loadingConceptos = false
          this.conceptos = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchTiposDeCondicion () {
      this.axios
        .get('/condiciones/tipos')
        .then(response => {
          this.tiposDeCondicion = response.data
          this.setearCondicionInicial()
          this.loadingTiposDeCondicion = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    setearCondicionInicial () {
      if (this.isEditing) {
        return
      }
      let min = {
        theOrder: Infinity
      }
      this.tiposDeCondicion.forEach(x => {
        if (x.theOrder < min.theOrder) {
          min = x
        }
      })
      this.condition.tipoDeCondicion = min
    },
    fetchSeasons () {
      this.axios
        .get('/seasons')
        .then(response => {
          this.loadingSeasons = false
          this.seasons = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    volverAPersonal () {
      if (this.condition.esJugador) {
        this.$router.push({ name: 'detalleJugador', params: { id: this.personalId, idClub: this.clubId } })
      } else if (this.condition.esCuerpoTecnico) {
        this.$router.push({ name: 'detalleCuerpoTecnico', params: { id: this.personalId, idClub: this.clubId } })
      } else {
        this.$router.go(-1)
      }
    },
    fetchCondition () {
      this.axios
        .get(`/condicion/${this.$route.params.id}`)
        .then(response => {
          this.condition = response.data
          this.personalId = this.condition.contratoObj.player.pk
          this.clubId = this.condition.contratoObj.club.pk
          this.fechaInicioMinimaSegunContrato = new Date(this.formatDateFromAPI(this.condition.contratoObj.startDate))
          this.fechaFinMaximaSegunContrato = new Date(this.formatDateFromAPI(this.condition.contratoObj.endDate))
          this.fetchContratos()
          this.playerName = `${this.condition.contratoObj.player.firstName} ${this.condition.contratoObj.player.lastName}`
          this.condition.fechaInicio = this.formatDate(response.data.fechaInicio)
          this.condition.fechaFin = this.formatDate(response.data.fechaFin)
          this.condition.primerVencimiento = this.formatDate(response.data.primerVencimiento)
          this.player = this.condition.contratoObj.player
          this.personalId = this.player.pk
          this.clubId = this.condition.contratoObj.club.pk
          this.loadingCondicion = false

          if (this.isRenovando) {
            const currentTipo = this.tiposDeCondicion.find(tipo => tipo.id === this.condition.tipoDeCondicion)
            const nextTipo = this.tiposDeCondicion.find(tipo => tipo.theOrder === currentTipo.theOrder + 1)
            if (nextTipo) {
              this.condition.tipoDeCondicion = nextTipo.id
            } else {
              this.condition.tipoDeCondicion = null
            }
          }
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    getPayload () {
      let payload = new FormData()
      payload.append('estado', 0)
      payload.append('temporada', this.condition.temporada)
      payload.append('fecha_inicio', this.condition.fechaInicio)
      payload.append('fecha_fin', this.condition.fechaFin)
      payload.append('concepto', this.condition.concepto)
      if (this.condition.tipoDeCondicion.id) {
        payload.append('tipo_de_condicion', this.condition.tipoDeCondicion.id)
      } else {
        payload.append('tipo_de_condicion', this.condition.tipoDeCondicion)
      }

      payload.append('contrato', this.condition.contrato)
      payload.append('importe', parseFloat(this.condition.importe))
      payload.append('observaciones', this.condition.observaciones || '')
      payload.append('frecuencia', this.condition.frecuencia)
      payload.append('tope', parseFloat(this.condition.tope))
      payload.append('tipo_importe', this.condition.tipoImporte)
      payload.append('moneda', this.condition.moneda)

      if (this.condition.frecuencia === ANUAL) {
        payload.append('cuotas', this.condition.cuotas)
        payload.append('primer_vencimiento', this.condition.primerVencimiento)
        payload.append('siguiente_vencimiento', this.condition.siguienteVencimiento)
      }
      if (this.esMoneda) {
        payload.append('descripcion_tipo_de_cambio', this.condition.descripcionTipoDeCambio)
        payload.append('tipo_de_cambio', this.condition.tipoDeCambio)
      }
      return payload
    },
    isValidForm () {
      return !this.$v.$invalid && this.isValidPrimerVencimiento() && this.isValidEndDate() &&
        this.isValidStartDateTemporada() && this.isValidEndDateTemporada() &&
        this.isValidEndDateContract()
    },
    condicionTerminada () {
      if (this.renovar) {
        this.renovarCondicion()
      } else {
        this.volverAPersonal()
      }
    },
    renovarCondicion () {
      this.$router.push({ name: 'renovarCondicion', params: { id: this.condicionId } })
      this.fetchData()
    },
    terminarCondicion () {
      this.$refs.terminarDialog.openDialog()
    },
    terminarCondicionYRenovar () {
      this.renovar = true
      this.$refs.terminarDialog.openDialog()
    },
    goBack () {
      this.goBackConfirmed = true
      this.volverAPersonal()
    },
    getUltimoVencimiento () {
      const ultimoPago = new Date(this.condition.primerVencimiento)
      const cantidadMesesExtra = (this.condition.cuotas - 1) * this.condition.siguienteVencimiento

      return new Date(ultimoPago.setMonth(ultimoPago.getMonth() + cantidadMesesExtra))
    },
    isValidEndDate () {
      const fechaInicio = this.condition.fechaInicio
      const fechaFin = this.condition.fechaFin
      const fechaInicioAnteriorAFechaFin = fechaInicio && fechaFin && (fechaFin > fechaInicio)

      return fechaInicioAnteriorAFechaFin
    },
    isValidEndDateTemporada () {
      const temporada = this.seasons.find(x => x.pk === this.condition.temporada)
      if (!temporada) {
        return false
      }
      const finTemporada = new Date(this.formatDateFromAPI(temporada.fechaFin))
      const finCondicion = new Date(this.condition.fechaFin)
      return finCondicion <= finTemporada
    },
    isValidStartDateTemporada () {
      const temporada = this.seasons.find(x => x.pk === this.condition.temporada)
      if (!temporada) {
        return false
      }
      const inicioTemporada = new Date(this.formatDateFromAPI(temporada.fechaInicio))
      const inicioCondicion = new Date(this.condition.fechaInicio)
      return inicioCondicion >= inicioTemporada
    },
    isValidEndDateContract () {
      const finCondicion = new Date(this.condition.fechaFin)
      const finContrato = this.fechaFinMaximaSegunContrato
      return finCondicion <= finContrato
    },
    isValidPrimerVencimiento () {
      if (this.condition.frecuencia !== ANUAL) {
        return true
      }
      const fechaInicio = this.condition.fechaInicio
      const fechaFin = this.condition.fechaFin
      const cuotas = this.condition.cuotas
      const primerVencimiento = this.condition.primerVencimiento

      return fechaInicio && fechaFin && primerVencimiento && cuotas &&
             primerVencimiento >= fechaInicio
    },
    fetchTiposDeCambio () {
      this.axios
        .get(`/condiciones/tipos-de-cambio?moneda=${this.condition.moneda}`)
        .then(response => {
          this.condition.descripcionTipoDeCambio = ''
          this.tiposDeCambio = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    onTipoCambioChange (event) {
      let tipo = this.tiposDeCambio.find(item => item.id === event)
      if (tipo) {
        this.condition.descripcionTipoDeCambio = tipo.description
      }
    },
    fetchMonedas () {
      this.axios
        .get('/condiciones/monedas')
        .then(response => {
          response.data.forEach((moneda) => {
            this.monedas.push({
              value: moneda.id,
              text: moneda.code
            })
          })
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },

  mounted () {
    this.loading = true
    this.fetchData()
  },

  watch: {
    'condition.contrato' () {
      for (let contrato of this.contratos) {
        if (contrato.id === this.condition.contrato) {
          this.fechaFinMaximaSegunContrato = new Date(this.formatDateFromAPI(contrato.endDate))
          this.fechaInicioMinimaSegunContrato = new Date(this.formatDateFromAPI(contrato.startDate))
          break
        }
      }
    },
    'condition.moneda' () {
      if (this.condition.moneda !== null) {
        this.fetchTiposDeCambio()
      }
    }
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em !important;
  }

  .toolbar-element {
    background: linear-gradient(#e2e2e2, #cbd1db);
  }

  .toolbar-title {
    font-size: 2.2em;
    font-family: SourceSansProLight, sans-serif;
    color: #293968;
  }
</style>
